import "./set-public-path";
import React from "react";
import ReactDOMClient from "react-dom/client";
import RootComponent from "./root.component.js";
import singleSpaReact from "single-spa-react";
import singleSpaCanopy from "single-spa-canopy";
import primaryNavBarStyles from "./practitioner/primary-navbar.styles.css";
import _NavContent from "./nav-content.component.js";
import _TopnavSecondary from "./topnav-secondary.component.js";
import _Dialog from "./dialog.component.js";
import { recalculatePrimaryNavHeight } from "./primary-nav-height.helpers.js";
import { recalculatePrimaryNavWidth } from "./primary-nav-width.helpers.js";
import { hasAccess } from "cp-client-auth!sofe";

const reactLifecycles = singleSpaReact({
  React,
  ReactDOMClient,
  rootComponent: RootComponent,
  domElementGetter,
});

const canopyLifecycles = singleSpaCanopy({
  mainContentTransition: false,
  domElementGetter,
  hotload: {
    module,
    __webpack_require__,
    dev: {
      enabled: true,
    },
  },
  overlay: {
    selectors: [`.${primaryNavBarStyles.navbar}`],
  },
});

export const NavContent = _NavContent;
export const TopnavSecondary = _TopnavSecondary;
export const Dialog = _Dialog;
export {
  primaryNavHeightObs,
  usePrimaryNavHeight,
} from "./primary-nav-height.helpers.js";
export {
  primaryNavWidthObs,
  usePrimaryNavWidth,
} from "./primary-nav-width.helpers.js";

export const bootstrap = [
  () => {
    // initialize navbar height ASAP
    recalculatePrimaryNavHeight();
    recalculatePrimaryNavWidth();
    return Promise.resolve();
  },
  canopyLifecycles.bootstrap,
  reactLifecycles.bootstrap,
];

export const mount = [reactLifecycles.mount, canopyLifecycles.mount];

export const unmount = [canopyLifecycles.unmount, reactLifecycles.unmount];

export const unload = [canopyLifecycles.unload];

export function checkPermissions(user: any, type: string) {
  // will be addressing permissions Fall 2020 and hopefully making this much better
  if (type === "transcripts-only")
    return hasAccess(user)(["transcripts"]) && !hasAccess(user)(["clients"]);
  else if (type === "notices-only") {
    return (
      hasAccess(user)(["tasks_notices"]) &&
      !hasAccess(user)(["forms", "transcripts"])
    );
  } else {
    throw new Error(
      `Second parameter to "checkPermissions()" ${type} was not provided or is invalid`
    );
  }
}

function domElementGetter() {
  let el = document.getElementById("primary-navbar");
  if (!el) {
    el = document.createElement("div");
    el.id = "primary-navbar";
    document.body.appendChild(el);
  }

  return el;
}
